import React, { useEffect, useCallback, useState} from 'react';
import PresetOption from './PresetOption.js';
import {connect} from 'react-redux';

const SourceResults = ({
    source,
    sequencerEngine,
    odd,
    alone,
    resultsSize,
    i,
    showPianoRoll,
    bottomHeight}
    ) => { 
        return (
            <div className="source-results">
             <div className="sample-options preset-options">
                {source.results.map(
                    (x) => <PresetOption sequencerEngine={sequencerEngine} preset={x}/>)}
              </div>
            </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SourceResults);
